import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=2c3f4e91&scoped=true&"
import script from "./MultiSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./MultiSelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=2c3f4e91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f4e91",
  null
  
)

export default component.exports